// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1fmPb","sendOtp":"AuthorizeToLogin_sendOtp__2Bp9P"};